import type { ParkingData, ParkingLayoutsData } from './parkingTypes';

export const FALLBACK_PARKING_DATA: ParkingData = {
  defaultCityId: '',
  cities: [],
};

export const FALLBACK_PARKING_LAYOUTS: ParkingLayoutsData = {
  layouts: [],
};

export const getParkingData = (): ParkingData => FALLBACK_PARKING_DATA;

export const getParkingLayouts = (): ParkingLayoutsData => FALLBACK_PARKING_LAYOUTS;
